module.exports = __webpack_public_path__ + "svgs/Abroad.abbe0b09365df869af2d136f69b4bbc0.svg";